// extracted by mini-css-extract-plugin
export default {"container":"Yl-z","disabled":"Zl-z","subtotal":"_l-z","legal":"am-z"};